/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface HubbleMenuBarData
 */
export interface HubbleMenuBarData {
  /**
   *
   * @type {number}
   * @memberof HubbleMenuBarData
   */
  numberShipmentsBookedToday: number;
  /**
   *
   * @type {number}
   * @memberof HubbleMenuBarData
   */
  revenueToday: number;
  /**
   *
   * @type {number}
   * @memberof HubbleMenuBarData
   */
  totalNumberSignificantContactsToday: number;
  /**
   *
   * @type {number}
   * @memberof HubbleMenuBarData
   */
  userNumberSignificantContactsToday: number;
  /**
   *
   * @type {number}
   * @memberof HubbleMenuBarData
   */
  starredCompanies: number;
  /**
   *
   * @type {number}
   * @memberof HubbleMenuBarData
   */
  starredShipments: number;
}

/**
 * Check if a given object implements the HubbleMenuBarData interface.
 */
export function instanceOfHubbleMenuBarData(
  value: object,
): value is HubbleMenuBarData {
  if (
    !("numberShipmentsBookedToday" in value) ||
    value["numberShipmentsBookedToday"] === undefined
  )
    return false;
  if (!("revenueToday" in value) || value["revenueToday"] === undefined)
    return false;
  if (
    !("totalNumberSignificantContactsToday" in value) ||
    value["totalNumberSignificantContactsToday"] === undefined
  )
    return false;
  if (
    !("userNumberSignificantContactsToday" in value) ||
    value["userNumberSignificantContactsToday"] === undefined
  )
    return false;
  if (!("starredCompanies" in value) || value["starredCompanies"] === undefined)
    return false;
  if (!("starredShipments" in value) || value["starredShipments"] === undefined)
    return false;
  return true;
}

export function HubbleMenuBarDataFromJSON(json: any): HubbleMenuBarData {
  return HubbleMenuBarDataFromJSONTyped(json, false);
}

export function HubbleMenuBarDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HubbleMenuBarData {
  if (json == null) {
    return json;
  }
  return {
    numberShipmentsBookedToday: json["numberShipmentsBookedToday"],
    revenueToday: json["revenueToday"],
    totalNumberSignificantContactsToday:
      json["totalNumberSignificantContactsToday"],
    userNumberSignificantContactsToday:
      json["userNumberSignificantContactsToday"],
    starredCompanies: json["starredCompanies"],
    starredShipments: json["starredShipments"],
  };
}

export function HubbleMenuBarDataToJSON(json: any): HubbleMenuBarData {
  return HubbleMenuBarDataToJSONTyped(json, false);
}

export function HubbleMenuBarDataToJSONTyped(
  value?: HubbleMenuBarData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    numberShipmentsBookedToday: value["numberShipmentsBookedToday"],
    revenueToday: value["revenueToday"],
    totalNumberSignificantContactsToday:
      value["totalNumberSignificantContactsToday"],
    userNumberSignificantContactsToday:
      value["userNumberSignificantContactsToday"],
    starredCompanies: value["starredCompanies"],
    starredShipments: value["starredShipments"],
  };
}
